<template>
<div>
    <form-errors :errors="formErrors" v-if="!hideFormErrors" />

    <p>Please review the suggested changes to this address.</p>

    <h5>Original Address:</h5>
    <p>
        {{ employerHire.address_1 }}
        {{ employerHire.address_2 }}
        <br/>
        <span>{{ employerHire.city }}, </span>
        <span>{{ employerHire.state }} </span>
        <span>&nbsp;</span>
        <span>{{ employerHire.postal_code }}</span>
    </p>

    <h5>Suggested Address:</h5>
    <p>
        <span :class="{ 'font-weight-bold': employerHire.geocode_data.geocoder_modified_address_1 }">
            {{ employerHire.geocode_data.address_1 }}
        </span>
        {{ employerHire.address_2 }}
        <br/>
        <span :class="{ 'font-weight-bold': employerHire.geocode_data.geocoder_modified_city }">
            {{ employerHire.geocode_data.city }},
        </span>
        <span :class="{ 'font-weight-bold': employerHire.geocode_data.geocoder_modified_state }">
            {{ employerHire.geocode_data.state }}
        </span>
        <span>&nbsp;</span>
        <span :class="{ 'font-weight-bold': employerHire.geocode_data.geocoder_modified_zip_code }">
            {{ employerHire.geocode_data.zip_code }}
        </span>
    </p>
</div>
</template>

<script>
import FormErrors from '@/components/FormErrors'
import FormMixin from '@/mixins/Form'

export default {
    mixins: [FormMixin],
    components: { FormErrors },
    props: {
        client: { required: true },
        employerHire: { required: true },
        hideFormErrors: { required: false, default: false },
    },
    data() {
        return {
            formRules: {},
            formLabels: {},
        }
    },
    methods: {
        onSubmit() {
            this.$emit('updated', {
                address_1: this.employerHire.address_1,
                address_2: this.employerHire.address_2,
                city: this.employerHire.geocode_data.city,
                state: this.employerHire.geocode_data.state,
                postal_code: this.employerHire.geocode_data.zip_code,
                phone: this.employerHire.phone,
                use_mailing_address: this.employerHire.use_mailing_address,
                mailing_address_1: this.employerHire.mailing_address_1,
                mailing_address_2: this.employerHire.mailing_address_2,
                mailing_city: this.employerHire.mailing_city,
                mailing_state: this.employerHire.mailing_state,
                mailing_postal_code: this.employerHire.mailing_postal_code,
            })
        },
    },
}
</script>
